import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconLocationPin: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0002 1.875C5.97933 1.875 2.7085 5.14583 2.7085 9.16667C2.7085 13.4317 6.62266 16.0166 9.21266 17.7275L9.6535 18.02C9.7585 18.09 9.87933 18.125 10.0002 18.125C10.121 18.125 10.2418 18.09 10.3468 18.02L10.7877 17.7275C13.3777 16.0166 17.2918 13.4317 17.2918 9.16667C17.2918 5.14583 14.021 1.875 10.0002 1.875ZM10.0993 16.6842L10.0002 16.7501L9.90099 16.6842C7.39266 15.0275 3.9585 12.7592 3.9585 9.16667C3.9585 5.835 6.6685 3.125 10.0002 3.125C13.3318 3.125 16.0418 5.835 16.0418 9.16667C16.0418 12.7592 12.6068 15.0283 10.0993 16.6842ZM10.0002 6.45833C8.50683 6.45833 7.29183 7.67333 7.29183 9.16667C7.29183 10.66 8.50683 11.875 10.0002 11.875C11.4935 11.875 12.7085 10.66 12.7085 9.16667C12.7085 7.67333 11.4935 6.45833 10.0002 6.45833ZM10.0002 10.625C9.196 10.625 8.54183 9.97083 8.54183 9.16667C8.54183 8.3625 9.196 7.70833 10.0002 7.70833C10.8043 7.70833 11.4585 8.3625 11.4585 9.16667C11.4585 9.97083 10.8043 10.625 10.0002 10.625Z"
      fill={color}
    />
  </svg>
);

export default IconLocationPin;
